<template>
  <v-form ref="form" v-model="valid" lazy-validation @close="close" @submit="submit">
    <v-card class="border">
      <v-card-title style="display: contents">
        <v-card class="card-header" style="box-shadow: none;">
          <span :class="{ 'text-h5' : !isDisplaySmall }">{{ message }}</span>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                text
                x-large
                right
                class="btn__icon pa-0"
                style="position: absolute; right: 15px; height: 50%"
                width="18"
                @click="close"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Закрыть</span>
          </v-tooltip>
        </v-card>
      </v-card-title>

      <v-card class="card-icon" v-if="!isDisplaySmall">
        <v-icon class="custom-icon" color="white">{{ icon }}</v-icon>
      </v-card>

      <v-card-text>
        <v-row style="display: block; margin-left: 12%; margin-right: 12%">
          <v-card outlined class="border card-info mt-2 mb-4">
            <div class="pa-4">
              <div v-for="(item, index) in basicInfoDevices" :key="index">
                <LabelValueInfo
                  :label="item.label"
                  :value="item.value"
                  :check="item.check"
                  :br-check="item.brCheck"
                  :is-check-size-small="isDisplaySmall"
                />
              </div>
            </div>
          </v-card>
          <v-text-field
            v-model="apartmentNumber"
            placeholder="Номер квартиры"
            type="number"
            outlined
            dense
            flat
            required
            :rules="[
              v => {
                if (item.type === 'G') return !!v || 'Введите номер квартиры';
                return (
                  (v && v >= item.diapason_from && v <= item.diapason_to) ||
                  `Диапазон квартир: ${item.diapason_from} - ${item.diapason_to}`
                );
              }
            ]"
            @keyup.enter="getCall()"
            class="input input-search border"
          />
          <v-autocomplete
            v-if="isSokol && !displayCardCall"
            v-model="callTarget"
            :items="sokolCallOptions"
            item-text="label"
            item-value="target"
            label="Куда звонить"
            outlined
            dense
            hide-details
            class="input border mb-4"
          />
          <v-card loading outlined class="border card-info mt-2 mb-2" v-if="displayCardCall">
            <div class="pa-4">
              <v-card-title class="justify-center">Квартира № {{ apartmentNumber }}</v-card-title>
              <p style="font-size: 18px; text-align: center">{{ displayTitle }}</p>
              <v-card-actions style="display: block; text-align: center;">
                <v-btn
                  v-if="resetButton"
                  class="text-none mt-3 px-2 btn-cell"
                  outlined
                  rounded
                  dark
                  :loading="isLoading"
                  @click.prevent="dropCall()"
                >
                  Сбросить
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
          <div style="display: block; text-align: center;">
            <v-btn
              v-if="!displayCardCall"
              outlined
              class="text-none mb-2 px-2 btn-cell"
              rounded
              dark
              :loading="isLoading"
              :disabled="callDisabled"
              @click="getCall()"
            >
              Вызов
            </v-btn>
          </div>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0" style="display: contents">
        <v-card class="card-footer-dialog">
          <div style="display: grid; grid-template-columns: 10% 1fr;" class="pr-8 pb-3">
            <div>
              <v-icon style="font-size: 50px;" color="#87A1B9">mdi-information-outline</v-icon>
            </div>
            <div style="text-align: justify">
              <p style="font-family: Arial, sans-serif;">
                Вы пытаетесь сделать тестовый вызов в квартиру. Пожалуйста, обратите внимание на важные моменты:
                <br><br>
                <span style="font-weight: bold; color: black;">1. Успешный вызов:</span>
                Ваш тестовый вызов в квартиру прошел успешно.
                Если у клиента пришел звонок на мобильное приложение или на трубку.
                <br><br>
                <span style="font-weight: bold; color: black;">2. Неуспешный вызов:</span>
                Убедитесь, что номер квартиры введен правильно.
                Проверьте, что ваше устройство подключено к сети и имеет стабильное интернет-соединение.
                <br>
                Убедитесь, что устройство, на которое вы совершаете вызов, включено и находится в рабочем состоянии.
              </p>
            </div>
          </div>
        </v-card>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import LabelValueInfo from '@/components/LabelValueInfo';
import { mapActions, mapGetters } from 'vuex';

export default {
  components: { LabelValueInfo },
  props: {
    model: String,
    icon: String,
    id: Number,
    message: String,
    item: {
      type: Object,
    },
    basicInfoDevices: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    valid: true,
    apartmentNumber: '',
    callTarget: 'both',
    sokolCallOptions: [
      { target: 'both', label: 'SIP (приложение) и аналоговая трубка' },
      { target: 'sip', label: 'SIP (приложение)' },
      { target: 'analog', label: 'Аналоговая трубка' },
    ],
    updateInterval: null,
    displayCardCall: false,
    isDisplaySmall: false,
    isLoading: false,
    updateResult: {},
  }),
  created () {
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },
  computed: {
    ...mapGetters({
      rules: 'Doorphone/rules',
      doorphone: 'Doorphone/doorphone',
    }),
    resetButton () {
      return this.updateResult.cWebCallStatus_Div !== '3';
    },
    controlCall () {
      return this.model === 'RV-3438';
    },
    isSokol () {
      return this.model === 'Sokol-Plus';
    },
    callDisabled () {
      if (this.item.type === 'G') {
        return !this.apartmentNumber;
      }
      return this.apartmentNumber < this.item.diapason_from || this.apartmentNumber > this.item.diapason_to;
    },
    displayTitle () {
      if (this.updateResult.cWebCallStatus_Div === '1') {
        return this.callDisconnect() || 'Звонок прерван.';
      }
      if (this.updateResult.cWebCallStatus_Div === '2' || !this.controlCall) {
        if (!this.isSokol) {
          return 'Идет звонок...';
        }
        const mode = this.sokolCallOptions.find(option => option.target === this.callTarget);
        return mode ? mode.label : 'Идет звонок...';
      }
      if (this.updateResult.cWebCallStatus_Div === '3') {
        return 'Идет загрузка...';
      }
      return 'Идет загрузка...';
    },
  },
  methods: {
    ...mapActions({
      getCallStart: 'Doorphone/getCallStart',
      callCheck: 'Doorphone/callCheck',
      getCallEnd: 'Doorphone/getCallEnd',
    }),
    checkSize () {
      this.isDisplaySmall = window.innerWidth <= 800;
    },
    getCall () {
      if (this.apartmentNumber <= 0) {
        this.$flash_danger('Введите номер квартиры!');
        return;
      }
      const target = this.isSokol ? (this.callTarget || 'both') : undefined;
      this.isLoading = true;
      this.getCallStart({
        doorphoneId: this.id,
        apartment: this.apartmentNumber,
        target,
      })
        .then(() => {
          this.displayCardCall = true;
          if (this.controlCall) {
            this.updateInterval = setInterval(() =>
              this.callCheck({
                doorphoneId: this.id,
              })
                .then((res) => {
                  this.updateResult = res;
                }), 2000);
          }
        })
        .catch(() => {
          this.$flash_warning('Не удалось позвонить');
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    dropCall () {
      this.isLoading = true;
      this.getCallEnd({
        doorphoneId: this.id,
      })
        .then(() => {
          this.displayCardCall = false;
          clearInterval(this.updateInterval);
          this.$flash_success('Звонок завершен');
        })
        .catch(() => {
          clearInterval(this.updateInterval);
          this.$flash_warning('Не удалось завершить звонок');
        })
        .finally(() => {
          this.isLoading = false;
          this.displayCardCall = false;
        });
    },
    callDisconnect () {
      this.updateResult.cWebCallStatus_Div = '3';
      clearInterval(this.updateInterval);
      setTimeout(() => this.dropCall(), 3000);
    },
    async submit () {
      await this.$emit('submit');
    },
    async close () {
      await this.$emit('close');
      this.apartmentNumber = '';
      // this.$emit('update:active', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-info {
  background-color: rgba(248, 248, 248, 0.35);
  color: black;
  width: auto;
  box-shadow: none;
}
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.card-icon {
  border-radius: 16px;
  top: 0;
  left: 0;
  position: absolute;
  width: 11%;
  height: 88px;
  max-height: 88px;
  text-align: center;
  background-color: #E0B389;
}
.card-footer-dialog {
  border-radius: 16px;
  text-align: center;
  padding-top: 10px;
  min-height: 100px;
  box-shadow: none;
  background-color: rgba(224, 179, 137, 0.5);
}
.btn-cell {
  width: 100%;
  max-width: 250px;
  background-color: #85B285;
  color: white;
}
.v-application p {
  margin-bottom: 0;
  font-family: 'Montserrat', sans-serif;
}
.border {
  border-radius: 16px;
}
.custom-icon {
  font-size: 45px;
  height: 100%;
}
.intercom-label {
  font-weight: 600;
  font-size: 14px;
  font-family: 'Montserrat', sans-serif;
}
.intercom-info {
  padding-left: 15px;
  font-weight: 400 !important;
  font-size: 14px;
  word-wrap: break-word;
  font-family: 'Montserrat', sans-serif;
}
.text-info {
  font-size: 15px;
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
  .text-info {
    padding: 20px;
  }
}
</style>
